<template>
    <div v-if="dataSource" :class="{ 'p-relative': true, 'height-100 d-flex flex-column': tab == 1 }">

        <Toolbar v-on:toolbar-button-click="onToolbarClick" />

        <div class="white-panel-items">
            <div class="wp-row">
                <div class="info-panel-text info-panel-text-uppercase">
                    <b>{{ dataSource.Data.Object.is_new_record ? $t("Новый_шаблон") : $t("Шаблон") }}</b>
                    <b v-if="!dataSource.Data.Object.is_new_record"> "{{ dataSource.Data.Object.Name[$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'] }}"</b>
                </div>
            </div>
        </div>

        <v-tabs
            v-model="tab"
            background-color="transparent"
            slider-size="3"
            :class="{
                'tab-selector-panel': true,
                'flex-grow-0': tab == 1
            }"
            mobile-breakpoint="0"
        >
            <v-tabs-slider color="#E43958"></v-tabs-slider>

            <v-tab
                v-for="item, index in tabs"
                :key="index"
                @click="onTabClick(item)"
            >
                {{ $t(item.name) }}
            </v-tab>

        </v-tabs>

        <v-tabs-items 
            v-model="tab" 
            :class="{
                'tab-content-panel': true,
                'flex-grow-1': tab == 1
            }"
        >
            <v-tab-item v-for="item, index in tabs" :key="index" :class="{'form-constructor-wrap-tab-item': item.type == 'Designer'}">

                <!-- Карточка -->
                <v-form v-if="item.type == 'Card'" class="wrapperForm" :ref="item.ref" lazy-validation>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="6" class="section-wrapper">
                            <v-card flat>
                                <v-card-text>
                                    <div class="form-box-title">{{ $t('Параметры_шаблона') }}</div>
                                    
                                    <!-- Шаблон_Тип_документа -->
                                    <v-row class="full-width-row" no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t('Тип_документа') }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ dataSource.Data.Object.DocumentTemplateType.Value }}
                                            </div>
                                            <v-select
                                                v-else
                                                :items="documentTemplateTypes"
                                                return-object
                                                :item-text="item => $t(item.Value)"
                                                v-model="dataSource.Data.Object.DocumentTemplateType"
                                                hide-details
                                                outlined
                                                dense
                                                append-icon="fas fa-chevron-down"
                                                :menu-props="{ bottom: true, offsetY: true }"
                                                required
                                                :rules="requiredRule"
                                            >
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    
                                    <!--поле Опубликовано-->
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{$t("Опубликовано")}}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ dataSource.Data.Object.IsPublic ? $t("Да") : $t("Нет") }}
                                            </div>
                                            <v-switch
                                                v-else
                                                v-model="dataSource.Data.Object.IsPublic"
                                                inset
                                                hide-details
                                                class="cust-switch"
                                            />
                                        </v-col>
                                    </v-row>

                                    <!-- Шаблон_Наименование_каз -->
                                    <v-row class="full-width-row" no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t('Наименование_каз') }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ dataSource.Data.Object.Name['kk-KZ'] }}
                                            </div>
                                            <v-text-field
                                                v-else
                                                v-model="dataSource.Data.Object.Name['kk-KZ']"
                                                hide-details
                                                outlined
                                                dense
                                                required
                                                :rules="requiredRule"
                                            >
                                            </v-text-field>
                                        </v-col>                                        
                                    </v-row>

                                    <!-- Шаблон_Наименование_рус -->
                                    <v-row class="full-width-row" no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t('Наименование_рус') }}</label>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <div v-if="isViewMode" class="onlyReadData">
                                                {{ dataSource.Data.Object.Name['ru-RU'] }}
                                            </div>
                                            <v-text-field
                                                v-else
                                                v-model="dataSource.Data.Object.Name['ru-RU']"
                                                hide-details
                                                outlined
                                                dense
                                                required
                                                :rules="requiredRule"
                                            >
                                            </v-text-field>
                                        </v-col>                                        
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>

                <!-- Конструктор -->
                <template v-if="item.type == 'Designer'">
                    <div 
                        :class="{
                            'form-constructor-wrap': true,
                            'fcw-is-edit': !isViewMode
                        }"
                    >

                        <!-- Меню реквизитов -->
                        <div v-if="!isViewMode" class="fcw-menu">

                            <div class="form-box-title">
                                <span>{{$t('Реквизиты')}}</span>
                            </div>

                            <v-text-field
                                v-model="searchDebounced"
                                append-icon="fas fa-search"
                                label="Поиск"
                                hide-details
                                solo
                                flat
                                clearable
                                class="fcw-menu-search"
                            ></v-text-field>

                            <v-list-group
                                v-for="item in requisitesTree"
                                :key="item.name"
                                v-model="item.active"
                                color="#125780"
                            >
                                <template v-slot:activator>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ isCustom(item) ? $t(item.name) : item.name[$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'] }}</v-list-item-title>
                                    </v-list-item-content>
                                </template>

                                <draggable
                                    :list="item.items"
                                    item-key="id"
                                    :clone="cloneField"
                                    :group="{ name: item.group, pull: isCustom(item) ? 'clone' : true, put: false }"
                                    :sort="false"
                                >
                                    <template v-for="child in item.items">
                                        <v-list-item v-if="child.visible" :key="child.id">
                                            <v-list-item-content>
                                                <v-list-item-title>{{ isCustom(child) ? $t(child.display_name) : child.name[$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'] }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </draggable>
                            </v-list-group>
                        </div>
                        
                        <!-- Схема -->
                        <v-form 
                            :class="{ 
                                'wrapperForm': true, 
                                'overflow-y-auto': true, 
                                'overflow-x-hidden': true,
                                'd-flex': !columns.length, 
                                'align-center': !columns.length 
                            }" 
                            :ref="item.ref" 
                            lazy-validation
                        >

                            <draggable
                                v-if="columns.length"
                                v-model="columns"
                                :disabled="isViewMode"
                                class="row row--dense"
                                handle=".handle-section"
                            >
                                <v-col v-for="(item) in columns" :key="item.id" cols="12" sm="12" :md="item.type == 2 ? '6' : '12'" class="section-wrapper">
                                    <v-card flat>
                                        <v-card-text>

                                            <div 
                                                :class="{
                                                    'form-box-title': true, 
                                                    'title-with-right-part': true,
                                                    'active-prop-element': item.id == activeObjPropSettings?.id && drawerPropSettings
                                                }"
                                                @click.stop="openPropColumnSettings(item)"
                                                v-tooltip.top-center='$t("Свойства")'
                                            >
                                                <i v-if="!isViewMode" class="fas fa-grip-vertical handle-section" v-tooltip.top-center='$t("Переместить")'></i>

                                                <span>{{ item.name?.[$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'] ?? 'Column' }}</span>

                                                <div v-if="!isViewMode" class="twrp-content">
                                                    <div class="twrp-action" v-tooltip.top-center='$t("Удалить")' @click.stop="onRemoveColumn(item.id)">
                                                        <v-icon role="button" small left>
                                                            fas fa-trash
                                                        </v-icon>
                                                    </div>
                                                </div>
                                            </div>

                                            <draggable 
                                                v-model="item.fields"
                                                :group="{ name: 'fields', put: ['fields', ...requisitesTreeGroups] }"
                                                :disabled="isViewMode"
                                                item-key="id"
                                                handle=".handle-field"
                                                class="draggable-field-area"
                                                @change="onChangeField"
                                            >
                                                
                                                <v-row 
                                                    v-for="field in item.fields" 
                                                    :key="field.id" 
                                                    :class="{
                                                        'full-width-row': item.type == 1, 
                                                        'active-prop-element': field.id == activeObjPropSettings?.id && drawerPropSettings}" 
                                                    @click.stop="openPropFieldSettings(field)"
                                                    v-tooltip.top-center='$t("Свойства")'
                                                    no-gutters
                                                >

                                                    <v-col cols="12" sm="12" :md="item.type == 1 ? '2' : '4'" class="d-flex align-center">
                                                        <i v-if="!isViewMode" class="fas fa-grip-vertical handle-field" v-tooltip.top-center='$t("Переместить")'></i>
                                                        <label class="f-label flex-1">{{ field.name[$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'] }}</label>
                                                    </v-col>
                                                    
                                                    <!-- Контент поля реквизита -->
                                                    <v-col>
                                                        <v-text-field v-if="field.requisite_type == 0" hide-details outlined dense readonly />
                                                        <v-switch v-if="field.requisite_type == 1" inset hide-details class="cust-switch" readonly />
                                                        <v-text-field v-if="field.requisite_type == 2" prepend-icon="mdi-calendar" hide-details outlined dense class="datepick-input" clearable readonly/>
                                                        <div v-if="field.requisite_type == 3" class="icon-click-row-group icrg-align-center">
                                                            <v-icon small>
                                                                fas fa-edit
                                                            </v-icon>
                                                            <div class="onlyReadData">
                                                                <v-workplace-chip :id="null" name="Иванов И.И." />
                                                            </div>
                                                        </div>
                                                        <div v-if="field.requisite_type == 4" class="icon-click-row-group icrg-align-center">
                                                            <v-icon small>
                                                                fas fa-edit
                                                            </v-icon>
                                                            <div class="onlyReadData">
                                                                <v-enterprise-chip name="Integro Company" />
                                                            </div>
                                                        </div>
                                                    </v-col>

                                                    <v-col v-if="!isViewMode" md="auto" class="d-flex ml-2">
                                                        <i class="fas fa-trash action-field" v-tooltip.top-center='$t("Удалить")' @click.stop="onRemoveField(item.id, field.id)"></i>
                                                    </v-col>

                                                </v-row>
                                            </draggable>

                                        </v-card-text>
                                    </v-card>
                                </v-col>                                
                            </draggable>
                            <div v-else class="cfl-placeholder">
                                {{ $t("Нет_колонок_для_отображения") }}
                            </div>

                        </v-form>

                    </div>

                    <v-navigation-drawer
                        v-model="drawerPropSettings"
                        absolute
                        right
                        temporary
                        max-width="400"
                        width="400"
                        class="drawerPropSettings wrapperForm"
                    >
                        <v-card flat>
                            <v-card-text>
                                <div class="form-box-title">
                                    <span>Свойства</span>
                                </div>
                                <template v-if="activeObjType == 'column'">
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Наименование_каз") }}</label>
                                        </v-col>
                                        <v-col>
                                            <v-text-field
                                                v-if="!isViewMode"
                                                :value="activeObjPropSettings.name['kk-KZ']"
                                                @input="activeObjPropSettings.name['kk-KZ'] = $event"
                                                hide-details
                                                outlined
                                                dense
                                                required
                                                :rules="requiredRule"
                                            >
                                            </v-text-field>
                                            <div v-else class="onlyReadData">{{activeObjPropSettings.name['kk-KZ']}}</div>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Наименование_рус") }}</label>
                                        </v-col>
                                        <v-col>
                                            <v-text-field
                                                v-if="!isViewMode"
                                                :value="activeObjPropSettings.name['ru-RU']"
                                                @input="activeObjPropSettings.name['ru-RU'] = $event"
                                                hide-details
                                                outlined
                                                dense
                                                required
                                                :rules="requiredRule"
                                            >
                                            </v-text-field>
                                            <div v-else class="onlyReadData">{{activeObjPropSettings.name['ru-RU']}}</div>
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-if="activeObjType == 'field'">
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Произвольный") }}</label>
                                        </v-col>
                                        <v-col>
                                            <div class="onlyReadData">{{$t(isCustom(activeObjPropSettings) ? 'Да' : 'Нет')}}</div>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Тип_данных") }}</label>
                                        </v-col>
                                        <v-col>
                                            <div class="onlyReadData">
                                                {{$t(getRequisiteTypeName(activeObjPropSettings))}}
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Ключ_реквизита") }}</label>
                                        </v-col>
                                        <v-col>
                                            <div v-if="isViewMode || !isCustom(activeObjPropSettings)" class="onlyReadData">
                                                {{activeObjPropSettings.key}}
                                            </div>
                                            <v-text-field
                                                v-else
                                                :value="activeObjPropSettings.key"
                                                @input="onRequisiteKeyEdit($event)"
                                                hide-details
                                                outlined
                                                dense
                                                required
                                                :rules="requiredRule"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Наименование_каз") }}</label>
                                        </v-col>
                                        <v-col>
                                            <div v-if="isViewMode || !isLocalTemplate" class="onlyReadData">
                                                {{activeObjPropSettings.name['kk-KZ']}}
                                            </div>
                                            <v-text-field
                                                v-else
                                                :value="activeObjPropSettings.name['kk-KZ']"
                                                @input="onRequisiteNameKzEdit($event)"
                                                hide-details
                                                outlined
                                                dense
                                                required
                                                :rules="requiredRule"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Наименование_рус") }}</label>
                                        </v-col>
                                        <v-col>
                                            <div v-if="isViewMode || !isLocalTemplate" class="onlyReadData">
                                                {{activeObjPropSettings.name['ru-RU']}}
                                            </div>
                                            <v-text-field
                                                v-else
                                                :value="activeObjPropSettings.name['ru-RU']"
                                                @input="onRequisiteNameRuEdit($event)"
                                                hide-details
                                                outlined
                                                dense
                                                required
                                                :rules="requiredRule"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" sm="12" md="4">
                                            <label class="f-label">{{ $t("Обязательное_поле") }}</label>
                                        </v-col>
                                        <v-col>
                                            <div 
                                                v-if="isViewMode || !isLocalTemplate"
                                                class="onlyReadData"
                                            >
                                                {{$t(getLogicalRequisiteInputValue() ? 'Да' : 'Нет')}}
                                            </div>
                                            <v-switch 
                                                v-else 
                                                :input-value="getLogicalRequisiteInputValue()" 
                                                @change="setLogicalRequisiteInputValue($event)" 
                                                inset 
                                                hide-details 
                                                class="cust-switch" 
                                            />
                                        </v-col>
                                    </v-row>                                    
                                </template>
                            </v-card-text>
                        </v-card>    
                    </v-navigation-drawer>
                </template>

            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';

import { httpAPI } from '@/api/httpAPI';
import sys from '@/services/system';
import Toolbar from '@/components/documents/Toolbar.vue';

const type = 'Documents.Template';
const customName = 'custom';

const prepareTree = function(origin, store, columns) {
    if (!origin || !Array.isArray(origin))
        return null;

    let existedFields = columns.flatMap(c => c.fields.map(f => f.id));

    let tree = origin.reduce((acc, curr) => {
        let { id, ...rest } = curr;
        let parent = { group: id, active: true, ...rest };
        parent.items = parent.items.filter(f => !existedFields.some(ef => ef == f.id)).map(f => ({ visible: true, group: parent.group, ...f }));
        acc.push(parent);
        return acc;
    }, []);

    let customGroupItems = store.getters['global/configuration/requisites/getRequisiteTypes'].map(e => ({
        visible: true,
        group: customName,
        id: sys.generateUUID(),
        display_name: e.value,
        name: { 'kk-KZ': e.value, 'ru-RU': e.value },
        requisite_type: e.id
    }));

    tree.push({ group: customName, active: true, name: 'Произвольные', items: customGroupItems });
    return tree;
};
const findSmallest = function(nums) {
    let seen = new Array(nums.length + 1).fill(false);

    for (let num of nums) {
        seen[num] = true;
    }

    let index = seen.findIndex(e => !e)
    return index < 0 ? 0 : index;
}

export default {
    name: "DesignerCard",
    components: { 
        draggable,
        Toolbar
    },
    asyncComputed: {
        documentTemplateTypes: {
            async get() {
                return await this.$store.dispatch('documents/references/getReference', { id: 1041 });
            },
            default: () => []
        }
    },
    computed: {
        ...mapGetters({ requiredRule: 'getRequiredRule' }),
        ...mapGetters('global/configuration/requisites', { requisiteTypes: 'getRequisiteTypes' }),
        isViewMode() {
            return this.dataSource.Data.FormId == "0207021";
        },
        menu() {
            let menu = [];

            if (!this.dataSource)
                return menu;

            if (!this.isViewMode && this.tab === 1) {
                let addColumn = {
                    Action: "AddColumn",
                    Icon: "column",
                    Items: null,
                    Text: this.$t("Одна_колонка"),
                    ToolTip: this.$t("Блок_на_всю_ширину"),
                    Type: null
                };

                let addTwoColumn = {
                    Action: "AddTwoColumn",
                    Icon: "two_column",
                    Items: null,
                    Text: this.$t("Две_колонки"),
                    ToolTip: this.$t("Блок_на_50%_ширины"),
                    Type: null
                };

                menu.push(addColumn, addTwoColumn);
            }

            return menu.concat(this.dataSource?.Data?.Menu);
        },
        tabs() {
            return [
                { name: 'Карточка', type: 'Card', ref: 'CardForm' },
                { name: 'Конструктор', type: 'Designer', ref: 'DesignerForm' }
            ];
        },
        requisitesTreeGroups() {
            return this.requisitesTree?.map(e => e.group) ?? [];
        },
        searchDebounced: {
            get: function() {
                return this.search;
            },
            set: _.debounce(function(value) {
                this.search = value;
            }, 500)
        },
        isLocalTemplate() {
            let isCommon = false;

            if (this.$route.query != null) {
                isCommon = this.$route.query.common ?? false;
            }

            return !isCommon;
        }
    },
    data() {
        return {
            tab: 0,
            dataSource: null,

            requisitesTree: null,
            columns: [],

            search: null,
            drawerPropSettings: false,
            activeObjType: null,
            activeObjPropSettings: null,
            
            respondToRouteChanges: true
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        async onToolbarClick(e, btn) {
            let action = this[btn.Action];

            if (typeof action != 'function') {
                this.$notify.warning(`Действие ${btn.Action} не реализовано`);
                return;
            }

            await this[btn.Action](btn);
        },
        //#region Toolbar
        AddColumn() {
            this.columns.push({ id: sys.generateUUID(), name: { 'kk-KZ': 'Баған', 'ru-RU': 'Колонка' }, fields: [], type: 1 });
        },
        AddTwoColumn() {
            this.columns.push({ id: sys.generateUUID(), name: { 'kk-KZ': 'Баған', 'ru-RU': 'Колонка' }, fields: [], type: 2 });
        },
        async SaveAndClose() {
            let validate_result = this.$refs.CardForm[0].validate();

            if (!validate_result) {
                this.$notify.alert(this.$t("Не_заполнены_обязательные_поля"));
                return;
            }

            let response = await httpAPI({ url: `api/actions/save?type=${type}`, method: 'POST', data: { Content: JSON.stringify({ parent: this.dataSource.Data.Object, childrens: null }) }, headers: { "isCommon": false } });

            if (response) {
                this.dataSource = response.data.Payload;
                this.$notify.success(response.data.Payload.Message);
            }
        },
        async Edit() {
            this.setOverlayVisible({ visible: true });

            let response = await httpAPI({ url: `api/actions/edit?type=${type}&id=${this.dataSource.Data.Object.id}`, method: 'GET', headers: { "isCommon": false } });

            if (response) {
                this.dataSource.Data.Menu = response.data.Payload.Menu;
                this.dataSource.Data.FormId = response.data.Payload.FormId;
            }

            this.setOverlayVisible({ visible: false });
        },
        async CopyDocumentTemplate() {
            let response = await httpAPI({
                url: `api/document-templates/templates/copy-to-local?id=${this.dataSource.Data.Object.id}`,
                method: 'GET',
            });

            if (!response)
                return;

            this.dataSource = response.data.Payload;
            this.columns = JSON.parse(this.dataSource.Data.Object.DesignScheme) ?? [];

            if (this.dataSource.Data.Object.Name == null)
                this.dataSource.Data.Object.Name = { 'kk-KZ': null, 'ru-RU': null };

            this.respondToRouteChanges = false;
            this.$router
                .replace({ query: { id: this.dataSource.Data.Object.id, common: false }, params: { id: this.dataSource.Data.Object.id, common: false } })
                .finally(() => this.respondToRouteChanges = true);

            this.$notify.success(response.data.Payload.Message);
        },
        //#endregion
        onTabClick() {
            
        },        
        cloneField(origin) {
            let copy = JSON.parse(JSON.stringify(origin));
            delete copy.visible;

            if (!this.isCustom(copy))
                return copy;
            
            let index = findSmallest(this.dataSource.Data.Object.Requisites.filter(r => r.KeyName.includes('RequisiteKey')).map(r => Number(r.KeyName.replace('RequisiteKey', ''))));
            copy.key = `RequisiteKey${ index }`;
            copy.id = sys.generateUUID();
            
            return copy;
        },
        isCustom(obj) {
            return obj.group === customName;
        },
        onRemoveColumn(columnId) {
            let column = this.columns.find(c => c.id === columnId);

            if (!column) return;

            for (let i = 0; i < column.fields.length; i++) {
                let field = column.fields[i];
                
                if (!this.isCustom(field)) {
                    let searchStr = this.search?.trim();
                    field.visible = searchStr ? sys.checkSearch(field.name[this.$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'], searchStr) : true;
                    this.requisitesTree.find(e => e.group == field.group).items.push(field);
                }

                this.deleteRequisite(column.fields[i].key);
            }

            this.columns = this.columns.filter(c => c.id !== columnId);
        },
        onRemoveField(columnId, fieldId) {
            let column = this.columns.find(c => c.id === columnId);

            if (!column) return;
            
            let field = column.fields.find(f => f.id == fieldId);
            
            if (!field) return;

            column.fields = column.fields.filter(f => f.id !== fieldId);

            if (!this.isCustom(field)) {
                let searchStr = this.search?.trim();
                field.visible = searchStr ? sys.checkSearch(field.name[this.$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'], searchStr) : true;
                this.requisitesTree.find(e => e.group == field.group).items.push(field);
            }

            this.deleteRequisite(field.key);
        },
        onChangeField(e) {
            if (!Object.prototype.hasOwnProperty.call(e, 'added')) return;            
            
            let field = e.added.element;

            if (this.dataSource.Data.Object.Requisites == null)
                this.dataSource.Data.Object.Requisites = [];

            let requisite = {
                __type: "DocumentRequisite:#Avrora.Objects.Modules.Docflow.DocumentTemplatesNew",
                Name: field.name,
                KeyName: field.key,
                RequisiteType: field.requisite_type,
                IsRequired: false
            };

            this.dataSource.Data.Object.Requisites.push(requisite);
        },
        deleteRequisite(requisiteKey) {
            let index = this.dataSource.Data.Object.Requisites.findIndex(r => r.KeyName === requisiteKey);

            if (index < 0)
                return;

            this.dataSource.Data.Object.Requisites.splice(index, 1);
        },
        openPropColumnSettings(objColumn){
            this.drawerPropSettings = !this.drawerPropSettings;
            this.activeObjType = 'column';
            this.activeObjPropSettings = objColumn;
        },
        openPropFieldSettings(objField){
            this.drawerPropSettings = !this.drawerPropSettings;
            this.activeObjType = 'field';
            this.activeObjPropSettings = objField;
        },
        getRequisiteTypeName(r) {
            return this.requisiteTypes.find(rt => rt.id == r.requisite_type)?.value ?? "";
        },
        onRequisiteKeyEdit(v) {
            let index = this.dataSource.Data.Object.Requisites.findIndex(r => r.KeyName === this.activeObjPropSettings.key);

            if (index < 0)
                return;

            this.dataSource.Data.Object.Requisites[index].KeyName = v;
            this.activeObjPropSettings.key = v;
        },
        onRequisiteNameKzEdit(v) {
            let index = this.dataSource.Data.Object.Requisites.findIndex(r => r.KeyName === this.activeObjPropSettings.key);

            if (index < 0)
                return;

            this.dataSource.Data.Object.Requisites[index].Name['kk-KZ'] = v;
            this.activeObjPropSettings.name['kk-KZ'] = v;
        },
        onRequisiteNameRuEdit(v) {
            let index = this.dataSource.Data.Object.Requisites.findIndex(r => r.KeyName === this.activeObjPropSettings.key);

            if (index < 0)
                return;

            this.dataSource.Data.Object.Requisites[index].Name['ru-RU'] = v;
            this.activeObjPropSettings.name['ru-RU'] = v;
        },
        getLogicalRequisiteInputValue() {
            let index = this.dataSource.Data.Object.Requisites.findIndex(r => r.KeyName === this.activeObjPropSettings.key);

            if (index < 0)
                return;

            return this.dataSource.Data.Object.Requisites[index].IsRequired == true;
                
        },
        setLogicalRequisiteInputValue(v) {
            let index = this.dataSource.Data.Object.Requisites.findIndex(r => r.KeyName === this.activeObjPropSettings.key);

            if (index < 0)
                return;

            this.dataSource.Data.Object.Requisites[index].IsRequired = v;
        },
        syncPulse() {
            const els = document.querySelectorAll('.drawerPropSettings .v-input.error--text fieldset');
            if (!els.length) return;
            // временно отключаем анимацию
            els.forEach(el => el.style.animation = 'none');
            // форсируем reflow, чтобы браузер принял изменения
            void document.body.offsetWidth;
            // включаем обратно (пусть берётся из CSS)
            els.forEach(el => el.style.animation = '');
        }
    },
    async beforeRouteEnter(to, from, next) {
        let dataSource = null;

        if (to.query.id === 'new')
            dataSource = (await httpAPI({ url: `api/actions/new?type=${type}`, method: 'GET', headers: { "isCommon": false } }))?.data.Payload ?? null;
        else
            dataSource = (await httpAPI({ url: `api/actions/open?type=${type}&id=${to.query.id}`, method: 'GET', headers: { "isCommon": to.query.common } }))?.data.Payload ?? null;
        
        if (!dataSource)
            return;
        
        if (dataSource.Data.Object.Name == null)
            dataSource.Data.Object.Name = { 'kk-KZ': null, 'ru-RU': null };
        
        let requisitesTree = (await httpAPI({ url: `api/document-templates/requisite-tree`, method: 'GET', headers: { "isCommon": true } }))?.data.Payload ?? null;

        next(vm => { 
            vm.dataSource = dataSource;
            vm.columns = JSON.parse(dataSource.Data.Object.DesignScheme) ?? [];
            vm.requisitesTree = prepareTree(requisitesTree, vm.$store, vm.columns)
        });
    },
    async beforeRouteUpdate(to, from, next) {
        if (!this.respondToRouteChanges) {
            next();
            return;
        }

        this.dataSource = null;

        if (to.query.id === 'new')
            this.dataSource = (await httpAPI({ url: `api/actions/new?type=${type}`, method: 'GET', headers: { "isCommon": false } }))?.data.Payload ?? null;
        else
            this.dataSource = (await httpAPI({ url: `api/actions/open?type=${type}&id=${to.query.id}`, method: 'GET', headers: { "isCommon": to.query.common } }))?.data.Payload ?? null;

        if (!this.dataSource) {
            next(false);
            return;
        }
        
        if (this.dataSource.Data.Object.Name == null)
            this.dataSource.Data.Object.Name = { 'kk-KZ': null, 'ru-RU': null };
        
        this.columns = JSON.parse(this.dataSource.Data.Object.DesignScheme) ?? [];
        this.requisitesTree = prepareTree((await httpAPI({ url: `api/document-templates/requisite-tree`, method: 'GET', headers: { "isCommon": true } }))?.data.Payload ?? null, this.$store, this.columns);

        next();
    },
    watch: {
        columns: {
            handler(newVal) {
                if (this.dataSource == null)
                    return;

                this.dataSource.Data.Object.DesignScheme = JSON.stringify(newVal);
            },
            deep: true
        },
        search: function(v) {
            let searchStr = v?.trim();

            for (let group of this.requisitesTree)
                for (let field of group.items)
                    field.visible = searchStr ? sys.checkSearch(field.name[this.$i18n.locale == 'kk' ? 'kk-KZ' : 'ru-RU'], searchStr) : true;
        },
        menu: {
            handler(v) {
                this.$store.commit('documents/toolbar/SET_MENU', { menu: v });
            }
        }
    },
    created() {
        (async() => {
            while(typeof this.$refs.CardForm === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs.CardForm[0].validate();
        })();
    },
    updated() {
        if (this.dataSource !== null) {
            this.$refs.CardForm[0].validate();
        }

        this.$nextTick(() => this.syncPulse());
    }
}
</script>